import Header from './Header';

const components = {
  Header
}


export default components;
